import { getLanguage, setLanguage as saveLanguage } from '../store';

const messages = {
  en: {
    appTitle: 'ExAgent Console',
    actions: {
      detail: 'Detail',
      cancel: 'Cancel',
      confirm: 'Confirm',
      login: 'Login',
      logout: 'Logout',
      search: 'Search',
      submit: 'Submit'
    },
    common: {
      actions: 'Actions',
      actualAmount: 'Actual credited amount',
      actualPaid: 'Actual paid',
      actualPayout: 'Actual payout',
      amount: 'Amount',
      applicationTime: 'Application time',
      areaCode: 'Area code',
      auditTime: 'Audit time',
      balance: 'Balance',
      channel: 'Channel',
      completedAt: 'Completed time',
      commission: 'Estimated commission',
      connectionFailed: 'Connection failed',
      createdAt: 'Created time',
      currency: 'Currency',
      currentCommissionRules: 'Current commission rules',
      currentRechargeTotal: 'Recharge total for current filters',
      date: 'Date',
      dateRangeTooLong: 'Date range cannot exceed 31 days',
      email: 'Email',
      end: 'End',
      error: 'Error',
      exchangeRate: 'Exchange rate',
      failReason: 'Fail Reason',
      firstRechargeUsers: 'First recharge users',
      hitTurnover: 'Matched turnover',
      max: 'Max',
      min: 'Min',
      month: 'Month',
      no: 'No',
      noLimit: 'Above',
      orderId: 'Order ID',
      packageName: 'Package',
      password: 'Password',
      payChannel: 'Payment channel',
      payMethod: 'Payment method',
      payStatus: 'Payment status',
      phone: 'Phone',
      ratePercent: 'Rate (%)',
      rechargeAmount: 'Recharge amount',
      rechargeUsers: 'Recharge users',
      requestFailed: 'Request failed',
      reviewStatus: 'Review status',
      sourceAmount: 'Original recharge',
      sourceCurrency: 'Original currency',
      sourceType: 'Source type',
      start: 'Start',
      status: 'Status',
      submitTime: 'Submit time',
      targetAmount: 'Converted amount',
      targetCurrency: 'Settlement currency',
      thirdOrderNo: 'Third-party order no',
      totalEarnings: 'Total earnings',
      transferableBalance: 'Transferable balance',
      updatedAt: 'Updated time',
      userId: 'User ID',
      earningsWalletBalance: 'Earnings Wallet Balance',
      walletBalance: 'Wallet balance',
      walletRecorded: 'Credited to wallet',
      walletRecordedAt: 'Wallet credited time',
      username: 'Username',
      withdrawAmount: 'Withdraw amount',
      withdrawUsers: 'Withdraw users',
      yes: 'Yes'
    },
    login: {
      missing: 'Please enter username and password'
    },
    menuGroups: {
      overview: 'Overview',
      playerBusiness: 'Player Business',
      myFunds: 'My Funds',
      settlement: 'Settlement'
    },
    menu: {
      commission: 'Commission Rules',
      dashboard: 'Acquisition Stats',
      recharges: 'Player Recharge Records',
      agentRechargeOrders: 'My Deposit Records',
      playerTopup: 'Player Top-up',
      earningsWithdrawOrders: 'Earnings Withdrawals',
      settlements: 'Settlement Records',
      walletRecords: 'Wallet Activity',
      users: 'Players',
      withdraws: 'Player Withdrawal Records'
    },
    pages: {
      activeUsers: 'Daily logins',
      commission: 'ExAgent commission',
      convertedTurnover: 'Converted turnover',
      currencyDetails: 'Currency details',
      dashboard: 'Acquisition stats',
      day1Retention: 'D1 retention',
      day3Retention: 'D3 retention',
      day7Retention: 'D7 retention',
      newPaidAmount: 'New paid amount',
      newPaidUsers: 'New paid users',
      newRegisteredAccounts: 'Registered accounts',
      newUsers: 'New accounts',
      rechargeTotal: 'Recharge total',
      recharges: 'Player Recharge Records',
      agentRechargeOrders: 'My Deposit Records',
      playerTopup: 'Player Top-up',
      agentRechargeOrderDetail: 'Deposit order detail',
      earningsWithdraw: 'Earnings Withdrawal',
      earningsWithdrawOrders: 'Earnings Withdrawals',
      settlementDetail: 'Settlement detail',
      settlementRecharge: 'Settlement turnover',
      settlements: 'Settlements',
      walletRecords: 'Wallet Activity',
      successfulRechargeAmount: 'Successful recharge amount',
      successfulWithdrawAmount: 'Successful withdraw amount',
      teamSuccessfulRecharge: 'Team successful recharge',
      tierDetails: 'Tier details',
      users: 'Users',
      withdrawRealTotal: 'Actual payout total',
      withdrawTotal: 'Withdraw total',
      withdraws: 'Player Withdrawal Records'
    },
    topup: {
      apply: 'Top up',
      playerId: 'Player ID',
      playerName: 'Player',
      playerAmount: 'Player amount',
      agentAmount: 'Wallet deduction',
      rate: 'Exchange rate',
      preview: 'Preview',
      confirm: 'Confirm top-up',
      currentBalance: 'Current top-up balance',
      remainingBalance: 'Remaining top-up balance',
      successTime: 'Successful time',
      successTitle: 'Top-up successful'
    },
    status: {
      hold: 'Hold',
      pending: 'Pending',
      settled: 'Settled'
    },
    payRecordStatus: {
      failed: 'Failed',
      ready: 'Pending',
      refunded: 'Refunded',
      riskReview: 'Risk review',
      rolledBack: 'Rolled back',
      submitted: 'Submitted',
      success: 'Success',
      utr: 'UTR submitted'
    },
    eadStatus: {
      ready: 'Waiting for payment',
      success: 'Successful',
      failed: 'Failed',
      processing: 'Processing'
    },
    wallet: {
      topupWallet: 'Top-up wallet',
      earningsWallet: 'Earnings wallet',
      topupBalance: 'Top-up wallet balance',
      earningsBalance: 'Available earnings',
      totalRechargeAmount: 'Total deposited amount',
      totalTopupAmount: 'Total player top-ups',
      totalEarnings: 'Total earnings',
      totalWithdrawAmount: 'Total withdrawn amount'
    },
    dashboard: {
      basicInfo: 'Account and binding',
      acquisitionStats: 'Acquisition statistics',
      name: 'Name'
    },
    walletRecords: {
      walletType: 'Wallet type',
      bizType: 'Business type',
      bizOrderNo: 'Business order no.',
      action: 'Action',
      amount: 'Balance change',
      balanceBefore: 'Balance before',
      balanceAfter: 'Balance after',
      remark: 'Remark'
    },
    walletTypes: {
      topup: 'Top-up wallet',
      earnings: 'Earnings wallet'
    },
    walletBusinessTypes: {
      ead: 'ExAgent deposit',
      eau: 'Player top-up',
      eaw: 'Earnings withdrawal',
      settlement: 'Commission settlement'
    },
    walletActions: {
      rechargeSuccess: 'Deposit credited',
      topupDeduct: 'Player top-up deducted',
      withdrawApply: 'Withdrawal deducted',
      withdrawRejectRefund: 'Rejected withdrawal refunded',
      withdrawFailRefund: 'Failed withdrawal refunded',
      withdrawRollbackRefund: 'Settlement rollback refund',
      settlementIncome: 'Commission credited'
    },
    reviewRecordStatus: {
      humanPass: 'Manual approved',
      humanReject: 'Manual rejected',
      programPass: 'Auto approved',
      programReject: 'Auto rejected',
      ready: 'Pending review'
    },
    exagentWithdrawStatus: {
      pendingReview: 'Pending review',
      rejected: 'Rejected',
      payoutProcessing: 'Payout processing',
      success: 'Successful',
      failed: 'Failed',
      compensate: 'Settlement rollback refunded'
    },
    withdrawPayType: {
      bank: 'Bank account',
      usdt: 'USDT wallet'
    },
    withdrawFields: {
      accountHolderName: 'Account holder name',
      accountNumber: 'Account number',
      bankName: 'Bank name',
      ifscCode: 'IFSC code',
      payeeMobile: 'Mobile number',
      payeeEmail: 'Email',
      payeeAddress: 'Address',
      network: 'Network',
      walletAddress: 'Wallet address',
      transferNetwork: 'Transfer network'
    },
    exagentWithdraw: {
      apply: 'Apply for withdrawal',
      availableBalance: 'Available earnings',
      availableTopupBalance: 'Available top-up balance',
      amount: 'Withdrawal amount',
      applicationAmount: 'Application amount',
      feeRate: 'Fee rate',
      feeAmount: 'Withdrawal fee',
      expectedPayout: 'Expected payout',
      payMethod: 'Withdrawal method',
      bank: 'Bank',
      channel: 'Withdrawal channel',
      channelLimits: 'Limits: {min} - {max}; amount step: {align}',
      unfinishedWarning: 'You already have a withdrawal being processed.',
      noBank: 'No withdrawal bank is currently available.',
      noChannel: 'No withdrawal channel is currently available.',
      requiredField: '{field} is required.',
      amountRequired: 'Enter a valid withdrawal amount.',
      insufficientBalance: 'The withdrawal amount exceeds the available top-up balance.',
      confirmTitle: 'Confirm withdrawal',
      confirmMessage: 'Withdraw {amount} {currency} to {payee}?',
      confirmWithdraw: 'Confirm withdrawal',
      previewing: 'Calculating fee...',
      submitted: 'Withdrawal request submitted.',
      payeeInformation: 'Payee information',
      orderDetail: 'Withdrawal order detail',
      auditRemark: 'Audit remark',
      payoutSubmittedAt: 'Payout submitted time',
      timelineApplied: 'Request submitted',
      timelineAudited: 'Manual review',
      timelineCompleted: 'Order completed'
    }
  },
  fr: {
    appTitle: 'Console ExAgent',
    actions: {
      detail: 'Detail',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      login: 'Connexion',
      logout: 'Deconnexion',
      search: 'Rechercher',
      submit: 'Soumettre'
    },
    common: {
      actions: 'Actions',
      actualAmount: 'Montant effectivement credite',
      actualPaid: 'Paiement reel',
      actualPayout: 'Paiement effectif',
      amount: 'Montant',
      applicationTime: 'Date de demande',
      areaCode: 'Indicatif',
      auditTime: 'Date de validation',
      balance: 'Solde',
      channel: 'Canal',
      completedAt: 'Date de finalisation',
      commission: 'Commission estimee',
      connectionFailed: 'Echec de la connexion',
      createdAt: 'Date de creation',
      currency: 'Devise',
      currentCommissionRules: 'Regles de commission actuelles',
      currentRechargeTotal: 'Total des depots selon les filtres',
      date: 'Date',
      dateRangeTooLong: 'La plage de dates ne peut pas depasser 31 jours',
      email: 'Email',
      end: 'Fin',
      error: 'Erreur',
      exchangeRate: 'Taux de change',
      failReason: "Raison de l'echec",
      firstRechargeUsers: 'Premiers depots',
      hitTurnover: 'Chiffre retenu',
      max: 'Maximum',
      min: 'Minimum',
      month: 'Mois',
      no: 'Non',
      noLimit: 'Au-dessus',
      orderId: 'ID commande',
      packageName: 'Package',
      password: 'Mot de passe',
      payChannel: 'Canal de paiement',
      payMethod: 'Mode de paiement',
      payStatus: 'Statut paiement',
      phone: 'Telephone',
      ratePercent: 'Taux (%)',
      rechargeAmount: 'Montant depose',
      rechargeUsers: 'Utilisateurs deposants',
      requestFailed: 'La requete a echoue',
      reviewStatus: 'Statut de revue',
      sourceAmount: 'Depot initial',
      sourceCurrency: 'Devise initiale',
      sourceType: 'Type de source',
      start: 'Debut',
      status: 'Statut',
      submitTime: 'Date de soumission',
      targetAmount: 'Montant converti',
      targetCurrency: 'Devise de reglement',
      thirdOrderNo: 'No commande tiers',
      totalEarnings: 'Gains totaux',
      transferableBalance: 'Solde transferable',
      updatedAt: 'Date de mise a jour',
      userId: 'ID utilisateur',
      earningsWalletBalance: 'Solde du portefeuille de gains',
      walletBalance: 'Solde portefeuille',
      walletRecorded: 'Credite sur le portefeuille',
      walletRecordedAt: 'Date de credit du portefeuille',
      username: "Nom d'utilisateur",
      withdrawAmount: 'Montant retire',
      withdrawUsers: 'Utilisateurs ayant retire',
      yes: 'Oui'
    },
    login: {
      missing: "Veuillez saisir le nom d'utilisateur et le mot de passe"
    },
    menuGroups: {
      overview: 'Vue d\'ensemble',
      playerBusiness: 'Opérations joueurs',
      myFunds: 'Mes fonds',
      settlement: 'Règlement'
    },
    menu: {
      commission: 'Règles de commission',
      dashboard: 'Statistiques acquisition',
      recharges: 'Historique des dépôts joueurs',
      agentRechargeOrders: 'Mes dépôts',
      playerTopup: 'Recharge joueur',
      earningsWithdrawOrders: 'Retraits des gains',
      settlements: 'Historique des règlements',
      walletRecords: 'Mouvements du portefeuille',
      users: 'Joueurs',
      withdraws: 'Historique des retraits joueurs'
    },
    pages: {
      activeUsers: 'Connexions du jour',
      commission: 'Commission ExAgent',
      convertedTurnover: 'Chiffre converti',
      currencyDetails: 'Details des devises',
      dashboard: 'Statistiques acquisition',
      day1Retention: 'Retention J1',
      day3Retention: 'Retention J3',
      day7Retention: 'Retention J7',
      newPaidAmount: 'Montant des nouveaux payeurs',
      newPaidUsers: 'Nouveaux payeurs',
      newRegisteredAccounts: 'Comptes inscrits',
      newUsers: 'Nouveaux comptes',
      rechargeTotal: 'Total des depots',
      recharges: 'Historique des depots joueurs',
      agentRechargeOrders: 'Mes depots',
      playerTopup: 'Recharge joueur',
      agentRechargeOrderDetail: 'Detail du depot',
      earningsWithdraw: 'Retrait des gains',
      earningsWithdrawOrders: 'Retraits des gains',
      settlementDetail: 'Detail du reglement',
      settlementRecharge: 'Chiffre de reglement',
      settlements: 'Reglements',
      walletRecords: 'Mouvements du portefeuille',
      successfulRechargeAmount: 'Montant des depots reussis',
      successfulWithdrawAmount: 'Montant des retraits reussis',
      teamSuccessfulRecharge: 'Depot reussi equipe',
      tierDetails: 'Details par palier',
      users: 'Utilisateurs',
      withdrawRealTotal: 'Total paiement effectif',
      withdrawTotal: 'Total des retraits',
      withdraws: 'Historique des retraits joueurs'
    },
    topup: {
      apply: 'Recharger',
      playerId: 'ID joueur',
      playerName: 'Joueur',
      playerAmount: 'Montant joueur',
      agentAmount: 'Debit du portefeuille',
      rate: 'Taux de change',
      preview: 'Apercu',
      confirm: 'Confirmer la recharge',
      currentBalance: 'Solde de recharge actuel',
      remainingBalance: 'Solde de recharge restant',
      successTime: 'Date de reussite',
      successTitle: 'Recharge reussie'
    },
    status: {
      hold: 'En attente',
      pending: 'En attente de validation',
      settled: 'Regle'
    },
    payRecordStatus: {
      failed: 'Echoue',
      ready: 'En attente',
      refunded: 'Rembourse',
      riskReview: 'Controle risque',
      rolledBack: 'Annule',
      submitted: 'Soumis',
      success: 'Reussi',
      utr: 'UTR soumis'
    },
    eadStatus: {
      ready: 'En attente du paiement',
      success: 'Reussi',
      failed: 'Echoue',
      processing: 'En cours'
    },
    wallet: {
      topupWallet: 'Portefeuille de recharge',
      earningsWallet: 'Portefeuille de gains',
      topupBalance: 'Solde du portefeuille de recharge',
      earningsBalance: 'Gains disponibles',
      totalRechargeAmount: 'Montant total depose',
      totalTopupAmount: 'Total des recharges joueurs',
      totalEarnings: 'Gains cumules',
      totalWithdrawAmount: 'Montant total retire'
    },
    dashboard: {
      basicInfo: 'Compte et liaison',
      acquisitionStats: 'Statistiques acquisition',
      name: 'Nom'
    },
    walletRecords: {
      walletType: 'Type de portefeuille',
      bizType: 'Type operation',
      bizOrderNo: 'No commande',
      action: 'Action',
      amount: 'Variation du solde',
      balanceBefore: 'Solde avant',
      balanceAfter: 'Solde apres',
      remark: 'Remarque'
    },
    walletTypes: {
      topup: 'Portefeuille de recharge',
      earnings: 'Portefeuille de gains'
    },
    walletBusinessTypes: {
      ead: 'Depot ExAgent',
      eau: 'Recharge joueur',
      eaw: 'Retrait des gains',
      settlement: 'Reglement commission'
    },
    walletActions: {
      rechargeSuccess: 'Depot credite',
      topupDeduct: 'Recharge joueur debitee',
      withdrawApply: 'Retrait debite',
      withdrawRejectRefund: 'Retrait rejete rembourse',
      withdrawFailRefund: 'Retrait echoue rembourse',
      withdrawRollbackRefund: 'Remboursement apres annulation du paiement',
      settlementIncome: 'Commission creditee'
    },
    reviewRecordStatus: {
      humanPass: 'Validation manuelle',
      humanReject: 'Rejet manuel',
      programPass: 'Validation auto',
      programReject: 'Rejet auto',
      ready: 'En attente de revue'
    },
    exagentWithdrawStatus: {
      pendingReview: 'En attente de revue',
      rejected: 'Rejete',
      payoutProcessing: 'Paiement en cours',
      success: 'Reussi',
      failed: 'Echoue',
      compensate: 'Rembourse apres annulation du paiement'
    },
    withdrawPayType: {
      bank: 'Compte bancaire',
      usdt: 'Portefeuille USDT'
    },
    withdrawFields: {
      accountHolderName: 'Nom du titulaire',
      accountNumber: 'Numero de compte',
      bankName: 'Nom de la banque',
      ifscCode: 'Code IFSC',
      payeeMobile: 'Numero de telephone',
      payeeEmail: 'Email',
      payeeAddress: 'Adresse',
      network: 'Reseau',
      walletAddress: 'Adresse du portefeuille',
      transferNetwork: 'Reseau de transfert'
    },
    exagentWithdraw: {
      apply: 'Demander un retrait',
      availableBalance: 'Gains disponibles',
      availableTopupBalance: 'Solde de recharge disponible',
      amount: 'Montant du retrait',
      applicationAmount: 'Montant demandé',
      feeRate: 'Taux des frais',
      feeAmount: 'Frais de retrait',
      expectedPayout: 'Montant net prévu',
      payMethod: 'Mode de retrait',
      bank: 'Banque',
      channel: 'Canal de retrait',
      channelLimits: 'Limites : {min} - {max} ; pas du montant : {align}',
      unfinishedWarning: 'Un retrait est deja en cours de traitement.',
      noBank: "Aucune banque de retrait n'est disponible actuellement.",
      noChannel: "Aucun canal de retrait n'est disponible actuellement.",
      requiredField: 'Le champ {field} est obligatoire.',
      amountRequired: 'Saisissez un montant de retrait valide.',
      insufficientBalance: 'Le montant dépasse le solde de recharge disponible.',
      confirmTitle: 'Confirmer le retrait',
      confirmMessage: 'Retirer {amount} {currency} vers {payee} ?',
      confirmWithdraw: 'Confirmer le retrait',
      previewing: 'Calcul des frais...',
      submitted: 'Demande de retrait soumise.',
      payeeInformation: 'Informations du beneficiaire',
      orderDetail: 'Detail de la demande de retrait',
      auditRemark: "Remarque d'audit",
      payoutSubmittedAt: 'Date de soumission du paiement',
      timelineApplied: 'Demande soumise',
      timelineAudited: 'Revue manuelle',
      timelineCompleted: 'Ordre finalise'
    }
  }
};

export const i18nState = {
  language: normalizeLanguage(getLanguage())
};

export function normalizeLanguage(language) {
  language = String(language || '').toLowerCase();
  if (language.indexOf('fr') === 0) return 'fr';
  if (language.indexOf('en') === 0) return 'en';
  return 'en';
}

export function setLanguage(language) {
  const value = normalizeLanguage(language);
  saveLanguage(value);
  i18nState.language = value;
  return value;
}

export function t(key) {
  const language = normalizeLanguage(i18nState.language);
  const parts = key.split('.');
  let current = messages[language];
  for (let i = 0; i < parts.length; i += 1) {
    current = current && current[parts[i]];
  }
  if (current) return current;
  current = messages.en;
  for (let i = 0; i < parts.length; i += 1) {
    current = current && current[parts[i]];
  }
  return current || key;
}

export default {
  install(Vue) {
    const reactiveState = Vue.observable(i18nState);
    Vue.prototype.$i18nState = reactiveState;
    Vue.prototype.$setLanguage = setLanguage;
    Vue.prototype.$t = t;
  }
};



// WEBPACK FOOTER //
// ./src/i18n/index.js